import { packageActionTypes as actionTypes } from "../../ActionTypes/Voss/packageActionTypes";

const initialState = {
    package: null,
    packageVersions: null
}
export default function PackageReducer(state = { ...initialState }, action) {

    let newState = { ...state };

    switch (action.type) {
        case actionTypes.STORE_PACKAGES:
            newState.packages = action.data;
            break;
        case actionTypes.STORE_PACKAGE:
            newState.package = action.data;
            break;
        case actionTypes.STORE_OFFER:
            newState.offer = action.data;
            break;
        case actionTypes.CLEAR:
            delete newState[action.key];
            break;
        case actionTypes.RESET:
            newState = { ...initialState };
            break;
        case actionTypes.STORE_PACKAGE_NAMES:
            newState.packageNames = action.data;
            break;
        case actionTypes.STORE_PRODUCT_NAMES:
            newState.productNames = action.data;
            break;
        case actionTypes.STORE_PACKAGE_VERSIONS:
            newState.packageVersions = action.data;
            break;
        default:
            return state;
    }

    return newState;
}
